// Google Analytics 4 Helper Functions
//
// Botaniksan.com GA4 Akış Bilgileri:
// Akış Adı: botaniksan.com
// Akış URL'si: https://botaniksan.com
// Akış Kimliği: 12164778731
// Ölçüm Kimliği: G-KCQZ1LC9RR
//
// GA4 tracking ID - Bu değer environment variable olarak ayarlanmalı
export const GA_TRACKING_ID =
  process.env.REACT_APP_GA_TRACKING_ID || "G-KCQZ1LC9RR";
export const GA_STREAM_ID = "12164778731";

// Google Analytics sayfa görüntüleme eventi
export const pageview = (url, title) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("config", GA_TRACKING_ID, {
      page_title: title,
      page_location: url,
    });
  }
};

// Genel event tracking fonksiyonu
export const event = (eventName, parameters = {}) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", eventName, parameters);
  }
};

// E-ticaret özel event fonksiyonları

// Ürün görüntüleme eventi
export const trackViewItem = (product) => {
  const currentPrice = product.sale_price || product.salePrice || product.price;
  const itemData = {
    currency: "TRY",
    value: currentPrice,
    items: [
      {
        item_id: product._id,
        item_name: product.name,
        category:
          product.categories && product.categories.length > 0
            ? product.categories[0].title
            : "Genel",
        price: currentPrice,
        quantity: 1,
      },
    ],
  };

  event("view_item", itemData);
};

// Sepete ekleme eventi
export const trackAddToCart = (product, quantity) => {
  const currentPrice = product.sale_price || product.salePrice || product.price;
  const itemData = {
    currency: "TRY",
    value: currentPrice * quantity,
    items: [
      {
        item_id: product._id,
        item_name: product.name,
        category:
          product.categories && product.categories.length > 0
            ? product.categories[0].title
            : "Genel",
        price: currentPrice,
        quantity: quantity,
      },
    ],
  };

  event("add_to_cart", itemData);
};

// Sepetten çıkarma eventi
export const trackRemoveFromCart = (product, quantity) => {
  const currentPrice = product.sale_price || product.salePrice || product.price;
  const itemData = {
    currency: "TRY",
    value: currentPrice * quantity,
    items: [
      {
        item_id: product._id,
        item_name: product.name,
        category:
          product.categories && product.categories.length > 0
            ? product.categories[0].title
            : "Genel",
        price: currentPrice,
        quantity: quantity,
      },
    ],
  };

  event("remove_from_cart", itemData);
};

// Sepet görüntüleme eventi
export const trackViewCart = (cartItems) => {
  if (!cartItems || cartItems.length === 0) {
    return;
  }

  const totalValue = cartItems.reduce((total, item) => {
    // Sepet verisi: doğrudan item üzerinde fiyat bilgileri var
    const currentPrice = item.sale_price || item.salePrice || item.price || 0;
    return total + currentPrice * (item.quantity || 0);
  }, 0);

  const items = cartItems.map((item) => {
    // Sepet verisi: doğrudan item üzerinde ürün bilgileri var
    const currentPrice = item.sale_price || item.salePrice || item.price || 0;
    return {
      item_id: item._id || item.id,
      item_name: item.name || "Unknown Product",
      category:
        item.categories && item.categories.length > 0
          ? item.categories[0].name
          : "Genel",
      price: currentPrice,
      quantity: item.quantity || 0,
    };
  });

  const cartData = {
    currency: "TRY",
    value: totalValue,
    items: items,
  };

  event("view_cart", cartData);
};

// Checkout başlatma eventi
export const trackBeginCheckout = (cartItems) => {
  if (!cartItems || cartItems.length === 0) {
    return;
  }

  const totalValue = cartItems.reduce((total, item) => {
    // Sepet verisi: doğrudan item üzerinde fiyat bilgileri var
    const currentPrice = item.sale_price || item.salePrice || item.price || 0;
    return total + currentPrice * (item.quantity || 0);
  }, 0);

  const items = cartItems.map((item) => {
    // Sepet verisi: doğrudan item üzerinde ürün bilgileri var
    const currentPrice = item.sale_price || item.salePrice || item.price || 0;
    return {
      item_id: item._id || item.id,
      item_name: item.name || "Unknown Product",
      category:
        item.categories && item.categories.length > 0
          ? item.categories[0].name
          : "Genel",
      price: currentPrice,
      quantity: item.quantity || 0,
    };
  });

  const checkoutData = {
    currency: "TRY",
    value: totalValue,
    items: items,
  };

  event("begin_checkout", checkoutData);
};

// Kargo bilgisi ekleme eventi
export const trackAddShippingInfo = (cartItems, shippingInfo) => {
  if (!cartItems || cartItems.length === 0) {
    return;
  }

  const totalValue = cartItems.reduce((total, item) => {
    // Sepet verisi: doğrudan item üzerinde fiyat bilgileri var
    const currentPrice = item.sale_price || item.salePrice || item.price || 0;
    return total + currentPrice * (item.quantity || 0);
  }, 0);

  const items = cartItems.map((item) => {
    // Sepet verisi: doğrudan item üzerinde ürün bilgileri var
    const currentPrice = item.sale_price || item.salePrice || item.price || 0;
    return {
      item_id: item._id || item.id,
      item_name: item.name || "Unknown Product",
      category:
        item.categories && item.categories.length > 0
          ? item.categories[0].name
          : "Genel",
      price: currentPrice,
      quantity: item.quantity || 0,
    };
  });

  const shippingData = {
    currency: "TRY",
    value: totalValue,
    shipping_tier: shippingInfo.shipping_tier || "Standart",
    items: items,
  };

  event("add_shipping_info", shippingData);
};

// Ödeme bilgisi ekleme eventi
export const trackAddPaymentInfo = (cartItems, paymentMethod) => {
  if (!cartItems || cartItems.length === 0) {
    return;
  }

  const totalValue = cartItems.reduce((total, item) => {
    // Sepet verisi: doğrudan item üzerinde fiyat bilgileri var
    const currentPrice = item.sale_price || item.salePrice || item.price || 0;
    return total + currentPrice * (item.quantity || 0);
  }, 0);

  const items = cartItems.map((item) => {
    // Sepet verisi: doğrudan item üzerinde ürün bilgileri var
    const currentPrice = item.sale_price || item.salePrice || item.price || 0;
    return {
      item_id: item._id || item.id,
      item_name: item.name || "Unknown Product",
      category:
        item.categories && item.categories.length > 0
          ? item.categories[0].name
          : "Genel",
      price: currentPrice,
      quantity: item.quantity || 0,
    };
  });

  const paymentData = {
    currency: "TRY",
    value: totalValue,
    payment_type: paymentMethod,
    items: items,
  };

  event("add_payment_info", paymentData);
};

// Satın alma eventi
export const trackPurchase = (order) => {
  if (!order || !order.products || order.products.length === 0) {
    return;
  }

  const items = order.products.map((item) => {
    // Sipariş verisi: item.product varsa onu kullan, yoksa item'ı kullan
    const product = item.product || item;
    const currentPrice =
      product.sale_price || product.salePrice || product.price || 0;
    return {
      item_id: product._id || product.id,
      item_name: product.name || "Unknown Product",
      category:
        product.categories && product.categories.length > 0
          ? product.categories[0].name
          : "Genel",
      price: currentPrice,
      quantity: item.quantity || 0,
    };
  });

  const purchaseData = {
    transaction_id: order._id || order.id,
    currency: "TRY",
    value: order.total_price || order.total || 0,
    shipping: order.shipping_cost || 0,
    tax: order.tax_amount || 0,
    affiliation: "Botaniksan Online Store",
    items: items,
  };

  event("purchase", purchaseData);
};

// Kategori/ürün listesi görüntüleme eventi
export const trackViewItemList = (items, listName) => {
  if (!items || items.length === 0) {
    return;
  }

  const itemsData = items.map((item, index) => {
    const currentPrice = item.sale_price || item.salePrice || item.price || 0;
    return {
      item_id: item._id,
      item_name: item.name,
      category:
        item.categories && item.categories.length > 0
          ? item.categories[0].name
          : "Genel",
      price: currentPrice,
      quantity: 1,
      index: index,
    };
  });

  const listData = {
    item_list_name: listName,
    items: itemsData,
  };

  event("view_item_list", listData);
};

// Ürün seçimi eventi (kategori listesinden)
export const trackSelectItem = (product, listName, index) => {
  const currentPrice =
    product.sale_price || product.salePrice || product.price || 0;
  const selectData = {
    item_list_name: listName,
    items: [
      {
        item_id: product._id,
        item_name: product.name,
        category:
          product.categories && product.categories.length > 0
            ? product.categories[0].title
            : "Genel",
        price: currentPrice,
        quantity: 1,
        index: index,
      },
    ],
  };

  event("select_item", selectData);
};

// Arama eventi
export const trackSearch = (searchTerm) => {
  const searchData = {
    search_term: searchTerm,
  };

  event("search", searchData);
};

// Arama sonucu seçimi eventi
export const trackSearchSelection = (searchTerm, selectedProduct, position) => {
  const currentPrice =
    selectedProduct.sale_price ||
    selectedProduct.salePrice ||
    selectedProduct.price ||
    0;
  const selectionData = {
    search_term: searchTerm,
    items: [
      {
        item_id: selectedProduct._id,
        item_name: selectedProduct.name,
        category:
          selectedProduct.categories && selectedProduct.categories.length > 0
            ? selectedProduct.categories[0].name
            : "Genel",
        price: currentPrice,
        quantity: 1,
        index: position,
      },
    ],
  };

  event("select_item", selectionData);
};

// GA4 Event Test Fonksiyonu - Manuel test için
export const testGA4Connection = () => {
  event("test_connection", {
    test_parameter: "botaniksan_ga4_test",
    timestamp: Date.now(),
  });
};



// WEBPACK FOOTER //
// ./src/utils/analytics.js